import { render, staticRenderFns } from "./PendingProformaList.vue?vue&type=template&id=7b2fe33f&scoped=true&lang=pug&"
import script from "./PendingProformaList.vue?vue&type=script&lang=js&"
export * from "./PendingProformaList.vue?vue&type=script&lang=js&"
import style0 from "./PendingProformaList.vue?vue&type=style&index=0&id=7b2fe33f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2fe33f",
  null
  
)

export default component.exports